import { ZoneContent } from "../../components/boundary"

export default function Zone () {

  return (

    <>
        <ZoneContent/>
    </>

  )

}